// extracted by mini-css-extract-plugin
export default {"manage-peripherals-grid-container":"page_manage-peripherals-grid-container__DjsqK","overflow-content":"page_overflow-content__GJJDa"};